// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '@med/app/auth/shared/auth.service';
import { decodeToken } from '@med/app/core/utils/decode-token';

@Injectable({
  providedIn: 'root',
})
export class HomeRedirectGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
  }

  canActivate(): UrlTree {
    const profile = decodeToken(this.authService.getAccessToken());
    const isHonorAuditor = profile?.authorities?.includes('KK Now Honor Auditor');
    console.log(profile, isHonorAuditor);

    if (isHonorAuditor) {
      return this.router.createUrlTree(['/honor/lockscreen-campaigns']);
    }

    return this.router.createUrlTree(['/lockscreen-campaigns']);
  }
}
